import React from 'react';

const headerIcon2 = () => {
  return (
    <svg width="30" height="26" viewBox="0 1 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0049 1L16.0049 5L5.00488 16H1.00488V12L12.0049 1Z"
        stroke="#565A5C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.00488 21H19.0049" stroke="#565A5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default headerIcon2;
